import * as React from 'react';
import { st, classes } from './WeeklyDateNavigation.st.css';
import { getCaptionText, getOffsetWeekDatesRange } from './dateUtils/dateUtils';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { IconButton } from '../IconButton';
import { ChevronLeft, ChevronRight } from '@wix/wix-ui-icons-common/on-stage';
import { Text } from '../Text';
import { DATA_HOOKS } from './constants';
import {
  WeeklyDateNavigationProps,
  WeeklyDateNavigationDefaultProps,
} from './types';

/** A Date navigation. */
export class WeeklyDateNavigation extends React.PureComponent<WeeklyDateNavigationProps> {
  static displayName = 'WeeklyDateNavigation';
  static defaultProps: WeeklyDateNavigationDefaultProps = {
    locale: 'en',
  };

  _navigateToNextDatesRange = () => {
    const {
      value: { startOfWeek },
      locale,
      firstDayOfWeek,
    } = this.props;
    const nextRange = getOffsetWeekDatesRange(startOfWeek, 1, {
      locale,
      firstDayOfWeek,
    });
    this.props.onChange(nextRange);
  };

  _navigateToPreviousDatesRange = () => {
    const {
      value: { startOfWeek },
      locale,
      firstDayOfWeek,
    } = this.props;
    const prevRange = getOffsetWeekDatesRange(startOfWeek, -1, {
      locale,
      firstDayOfWeek,
    });
    this.props.onChange(prevRange);
  };

  _getCaptionText() {
    const { value, locale } = this.props;
    return getCaptionText(value, locale);
  }

  render() {
    const {
      className,
      prevArrowAriaLabel,
      prevArrowAriaLabelledBy,
      nextArrowAriaLabel,
      nextArrowAriaLabelledBy,
      captionId,
    } = this.props;

    return (
      <TPAComponentsConsumer>
        {({ rtl }) => {
          return (
            <div
              data-hook={this.props['data-hook']}
              className={st(classes.root, { rtl }, className)}
            >
              <IconButton
                className={classes.arrow}
                icon={<ChevronLeft />}
                data-hook={DATA_HOOKS.Prev}
                onClick={this._navigateToPreviousDatesRange}
                aria-labelledby={prevArrowAriaLabelledBy}
                aria-label={prevArrowAriaLabel}
              />
              <Text
                id={captionId}
                data-hook={DATA_HOOKS.Text}
                className={classes.text}
              >
                {this._getCaptionText()}
              </Text>
              <IconButton
                className={classes.arrow}
                icon={<ChevronRight />}
                data-hook={DATA_HOOKS.Next}
                onClick={this._navigateToNextDatesRange}
                aria-labelledby={nextArrowAriaLabelledBy}
                aria-label={nextArrowAriaLabel}
              />
            </div>
          );
        }}
      </TPAComponentsConsumer>
    );
  }
}
